import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import UtilsUrl from "../utils/UtilsUrl";
import { PagerFooter } from "./PagedCardTable";
import { productImageSrc, onProductImageError } from "../utils/productImage";

// Server-side pagination: pass `remote` = { page, sizePerPage, totalSize, onPageChange(page, sizePerPage) }
const DataTableProducts = ({ listProduits, kpisale, remote }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [products, setProducts] = useState(listProduits);
  useEffect(() => {
    setProducts(listProduits);
  }, [listProduits]);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  function logoFormatter(cell, row) {
    return (
      <span>
        <img
          alt=""
          src={productImageSrc(row.imagePath)}
          onError={onProductImageError}
          className="rounded"
          style={{
            width: "48px",
            height: "48px",
            objectFit: "cover",
            border: "1px solid #dee2e6",
            backgroundColor: "#f8f9fa",
          }}
        ></img>
      </span>
    );
  }

  function SKUFormatter(cell, row) {
    if (cell === null || cell === "") {
      return <span className="text-muted">-</span>;
    } else {
      return <span>{cell}</span>;
    }
  }
  function buttonFormatter(cell, row) {
    console.log("row", row);
    if (row.isComplited === 1) {
      return (
        <span>
          <button
            className="btn btn-sm btn-outline-dark"
            title="Ajouter des spécificités"
            onClick={(e) => {
              sessionStorage.setItem("idProduct", cell);
              navigate(`/addSpecificityToProduct`);
            }}
          >
            <i className="fas fa-plus mr-1"></i> Ajouter
          </button>
        </span>
      );
    } else {
      return (
        <span>
          <button
            className="btn btn-sm btn-dark"
            title="Compléter le produit"
            onClick={(e) => {
              sessionStorage.setItem("idProduct", cell);
              navigate(`/updateProduct`);
            }}
          >
            <i className="fas fa-pencil-alt mr-1"></i> Compléter
          </button>
        </span>
      );
    }
  }

  function buttonDeleteFormatter(cell, row) {
    if (row.isDeleted === 0) {
      return (
        <span>
          <button
            className="btn btn-sm btn-outline-danger"
            title="Supprimer"
            onClick={(e) => {
              let deletedAndRestoreModel;

              deletedAndRestoreModel = {
                idProduct: cell,
                isDeleted: 1,
              };

              dispatch(deleteAndRestoreProduct(deletedAndRestoreModel));
              setOpenInfoAlert(true);

              setInfoAlertText("Element supprimé avec succée ");

              setProducts(products.filter((dept) => dept.id !== cell));
            }}
          >
            <i className="fas fa-trash"></i>
          </button>
        </span>
      );
    } else if (row.isDeleted === 1) {
      return (
        <span>
          <button
            className="btn btn-sm btn-outline-info"
            title="Restaurer"
            onClick={(e) => {
              let deletedAndRestoreModel;

              deletedAndRestoreModel = {
                idProduct: cell,
                isDeleted: 0,
              };

              dispatch(deleteAndRestoreProduct(deletedAndRestoreModel));
              setInfoAlertText("Element restauré avec succée ");
              setOpenInfoAlert(true);

              setProducts(products.filter((dept) => dept.id !== cell));
            }}
          >
            <RestoreFromTrashRoundedIcon fontSize="small" />
          </button>
        </span>
      );
    }
  }
  const columnsKPI = [
    {
      dataField: "productCode",
      text: "Code de produit",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "barcode",
      text: "code à barre",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "name",
      text: "Libellé",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "count",
      text: "Commande",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "total_quantity",
      text: "Quantité Totale",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "totalAmountInitialPrice",
      text: "Prix Initial",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "totalAmountSellingPrice",
      text: "Prix de Vente",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "promotionPercentage",
      text: "Promotion (%)",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },

  ];
  const columns = [
    {
      dataField: "id",
      text: "Image",
      formatter: logoFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "name",
      text: "Libellé",
      formatter: (cell) => <strong>{cell}</strong>,
      style: { verticalAlign: "middle" },
    },
    {
      dataField: "productCode",
      text: "Code article",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "barcode",
      text: "Code à barre",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "sku",
      text: "SKU",
      align: "center",
      formatter: SKUFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      formatter: (cell) =>
        cell === null || cell === undefined || cell === "" ? (
          <span className="text-muted">-</span>
        ) : (
          <span className="badge badge-light border">{cell}</span>
        ),
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },

    {
      dataField: "id",
      text: "Compléter",
      formatter: buttonFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "id",
      text: "Actions",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
  ];

  const specificities = (row) => {

    if (row.specificities.length > 0) {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th>Libellé</th>
              <th>Valeur</th>
              <th>Description</th>

            </tr>
          </thead>
          <tbody>
            {row.specificities &&
              row.specificities.map((element, i) => (
                <tr key={i}>
                  <td>{element.name}</td>

                  <td>{element.value}</td>

                  <td className="text-center">
                    {element.description}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      );
    }

  }
  const expandRow = {
    renderer: (row) => (
      <div
        className="p-3 rounded"
        style={{ backgroundColor: "#f8f9fa", border: "1px solid #e9ecef" }}
      >
        <div className="row">
          <div className="col-md-4 mb-2">
            <small className="text-muted d-block">Famille de produits</small>
            <strong>{row.familyName}</strong>
          </div>
          <div className="col-md-4 mb-2">
            <small className="text-muted d-block">
              Sous-Famille de produits
            </small>
            <strong>{row.subFamilyName}</strong>
          </div>
          <div className="col-md-4 mb-2">
            <small className="text-muted d-block">Catégorie de produits</small>
            <strong>{row.categoryName}</strong>
          </div>
        </div>
        <div className="mb-2">
          <small className="text-muted d-block">Description</small>
          <span>{row.description || "-"}</span>
        </div>
        {specificities(row)}

        {/* <p>
          expandRow.renderer callback will pass the origin row object to you
        </p> */}
      </div>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = remote
    ? {
        pageButtonRenderer,
        custom: false,
        page: remote.page,
        sizePerPage: remote.sizePerPage,
        totalSize: remote.totalSize,
        sizePerPageList: [10, 25, 50, 100],
      }
    : {
        pageButtonRenderer,
      };
  const handleRemoteTableChange = (type, { page, sizePerPage }) => {
    if (type === "pagination") remote.onPageChange(page, sizePerPage);
  };

  return (
    <div
      className="card"
      style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
    >
      <div className="card-header">
        <h3 className="card-title">
          <i className="fas fa-boxes mr-2"></i>Produits
          <span className="badge badge-dark ml-2">
            {remote ? remote.totalSize : products.length}
          </span>
        </h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={products}
          columns={kpisale ? columnsKPI : columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0 mb-3 align-items-center">
                {!remote && (
                  <div>
                    <SearchBar
                      {...props.searchProps}
                      className="custome-search-field"
                      style={{ color: "black" }}
                      placeholder="Chercher"
                    ></SearchBar>
                  </div>
                )}
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row table-responsive mx-0">
                <BootstrapTable
                  {...props.baseProps}
                  {...(remote
                    ? { remote: { pagination: true }, onTableChange: handleRemoteTableChange }
                    : {})}
                  {...(remote ? {} : { pagination: paginationFactory(options) })}
                  headerClasses="thead-light"
                  wrapperClasses="w-100"
                  striped
                  hover
                  condensed
                  expandRow={kpisale ? false : expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
      {remote && (
        <PagerFooter
          page={remote.page}
          size={remote.sizePerPage}
          total={remote.totalSize}
          totalPages={Math.ceil(remote.totalSize / remote.sizePerPage)}
          onPageChange={(p) => remote.onPageChange(p, remote.sizePerPage)}
          onSizeChange={(newSize) => remote.onPageChange(1, newSize)}
        />
      )}

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataTableProducts;
